import React from "react";
import Navbar from "../components/common/Navbar";
import MorseCodeVisualiser from "../components/tutorialPage/MorseCodeVisualiser";
import "../styles/tutorialPage/TutorialPage.css";

const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
const numbers = "0123456789".split("");
const specialCharacters = [
  "‘",
  "“",
  ":",
  ";",
  ",",
  "/",
  "-",
  "(",
  ")",
  ".",
  "?",
  "=",
  "+",
  "@",
];

export default function TutorialPage() {
  return (
    <div>
      <Navbar />
      <div className="container-fluid containerDesktop">
        <div className="mt-4 title">Tutorial</div>
        <div className="container">
          <h2 className="lettersTitle">Alphabets</h2>
          <div className="morse-grid">
            {letters.map((letter) => (
              <MorseCodeVisualiser key={letter} character={letter} />
            ))}
          </div>

          <h2 className="lettersTitle">Numbers</h2>
          <div className="morse-grid">
            {numbers.map((number) => (
              <MorseCodeVisualiser key={number} character={number} />
            ))}
          </div>

          <h2 className="lettersTitle">Special Characters</h2>
          <div className="morse-grid">
            {specialCharacters.map((symbol) => (
              <MorseCodeVisualiser key={symbol} character={symbol} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
